import Base from './base';
import jsCookies from 'js-cookie';
import { AES as crypto } from 'crypto-js';
import encr, { decr } from '../../util/encr';

const subset = (obj, keys) =>
  !keys
    ? { ...obj }
    : keys
        .filter(k => obj.hasOwnProperty(k))
        .reduce((o, k) => ({ ...o, [k]: obj[k] }), {});

export default class Cookie extends Base {
  constructor(name, defaults = {}, options = {}) {
    super(defaults, options);
    const { paths, cookies = jsCookies } = options;
    this.name = name;
    this.paths =
      paths === undefined ? paths : paths instanceof Array ? paths : [paths];
    this.cookies = cookies;
  }

  static PREFIX = '@@cookie';

  read(state) {
    const {
      payload: { options: { options } = {} }
    } = this.buildAction({});
    const data = this.decrypt(this.cookies.get(this.name, options) || '{}');
    return {
      ...state,
      ...subset(data, this.paths)
    };
  }

  write(state) {
    const {
      payload: { options: { options } = {} }
    } = this.buildAction({});
    this.cookies.set(
      this.name,
      this.encrypt(subset(state, this.paths)),
      options
    );
  }

  encrypt(value) {
    try {
      return crypto.encrypt(JSON.stringify(value), encr()).toString();
    } catch (e) {
      return crypto.encrypt(JSON.stringify({}), encr()).toString();
    }
  }

  decrypt(value) {
    try {
      return decr(value);
    } catch (e) {
      return {};
    }
  }
}



// WEBPACK FOOTER //
// ./js/store/middleware/cookie.js